import React from 'react';

export default class Header2 extends React.Component {
  getStartText() {
    return this.props.text.split(this.props.decoration.text)[0];
  }
  getEndText() {
    return this.props.text.split(this.props.decoration.text)[1];
  }
  renderHeader() {
    return (
      <h2 className={`text ${this.props.className ? this.props.className : ''}`}>
        {this.props.text}
      </h2>
    )
  }
  renderModule() {
    let component = this.renderHeader();

    if (this.props.decoration) {
      component = (
        <h2 className={`text ${this.props.className ? this.props.className : ''}`}>
          {
            this.getStartText()
          }
          <span className={`${this.props.decoration.type} ${this.props.decoration.color}`}>
          {
            this.props.decoration.text
          }
          </span>
          {
            this.getEndText()
          }
        </h2>
      );
    }

    return component;
  }
  render() {
    return (
      this.renderModule()
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/typographies/header2.js